import type { TFunction } from 'i18next'

// 基本的なタグの型定義
export type Tag = {
  key: string
  value: string
  label: string
}

export type Section = {
  id: string
  label: string
  alwaysOpen?: boolean
  tags: Tag[]
}

// i18nの翻訳データからセクションとタグを生成する関数
export const getSections = (t: TFunction): Section[] => {
  return [
    {
      id: t('search.sections.popular.id'),
      label: t('search.sections.popular.label'),
      alwaysOpen: true,
      tags: [
        {
          key: t('search.sections.popular.tags.feature_snow.key'),
          value: t('search.sections.popular.tags.feature_snow.value'),
          label: t('search.sections.popular.tags.feature_snow.label'),
        },
        {
          key: t('search.sections.popular.tags.feature_furusato.key'),
          value: t('search.sections.popular.tags.feature_furusato.value'),
          label: t('search.sections.popular.tags.feature_furusato.label'),
        },
        {
          key: t('search.sections.popular.tags.regional_monitor.key'),
          value: t('search.sections.popular.tags.regional_monitor.value'),
          label: t('search.sections.popular.tags.regional_monitor.label'),
        },
        {
          key: t('search.sections.popular.tags.no_car.key'),
          value: t('search.sections.popular.tags.no_car.value'),
          label: t('search.sections.popular.tags.no_car.label'),
        },
        {
          key: t('search.sections.popular.tags.feature_bus.key'),
          value: t('search.sections.popular.tags.feature_bus.value'),
          label: t('search.sections.popular.tags.feature_bus.label'),
        },
        {
          key: t('search.sections.popular.tags.room_environment_walking.key'),
          value: t('search.sections.popular.tags.room_environment_walking.value'),
          label: t('search.sections.popular.tags.room_environment_walking.label'),
        },
      ],
    },
    {
      id: t('search.sections.experience.id'),
      label: t('search.sections.experience.label'),
      alwaysOpen: true,
      tags: [
        {
          key: t('search.sections.experience.tags.feature_sea.key'),
          value: t('search.sections.experience.tags.feature_sea.value'),
          label: t('search.sections.experience.tags.feature_sea.label'),
        },
        {
          key: t('search.sections.experience.tags.feature_forest.key'),
          value: t('search.sections.experience.tags.feature_forest.value'),
          label: t('search.sections.experience.tags.feature_forest.label'),
        },
        {
          key: t('search.sections.experience.tags.feature_mud.key'),
          value: t('search.sections.experience.tags.feature_mud.value'),
          label: t('search.sections.experience.tags.feature_mud.label'),
        },
        {
          key: t('search.sections.experience.tags.feature_snow.key'),
          value: t('search.sections.experience.tags.feature_snow.value'),
          label: t('search.sections.experience.tags.feature_snow.label'),
        },
        {
          key: t('search.sections.experience.tags.feature_harvest.key'),
          value: t('search.sections.experience.tags.feature_harvest.value'),
          label: t('search.sections.experience.tags.feature_harvest.label'),
        },
        {
          key: t('search.sections.experience.tags.feature_english.key'),
          value: t('search.sections.experience.tags.feature_english.value'),
          label: t('search.sections.experience.tags.feature_english.label'),
        },
        {
          key: t('search.sections.experience.tags.feature_development.key'),
          value: t('search.sections.experience.tags.feature_development.value'),
          label: t('search.sections.experience.tags.feature_development.label'),
        },
        {
          key: t('search.sections.experience.tags.feature_different_age.key'),
          value: t('search.sections.experience.tags.feature_different_age.value'),
          label: t('search.sections.experience.tags.feature_different_age.label'),
        },
        {
          key: t('search.sections.experience.tags.service_type_elementary.key'),
          value: t('search.sections.experience.tags.service_type_elementary.value'),
          label: t('search.sections.experience.tags.service_type_elementary.label'),
        },
        {
          key: t('search.sections.experience.tags.service_type_both.key'),
          value: t('search.sections.experience.tags.service_type_both.value'),
          label: t('search.sections.experience.tags.service_type_both.label'),
        },
        {
          key: t('search.sections.experience.tags.short_stay_program_3n4d.key'),
          value: t('search.sections.experience.tags.short_stay_program_3n4d.value'),
          label: t('search.sections.experience.tags.short_stay_program_3n4d.label'),
        },
      ],
    },
    {
      id: t('search.sections.facility.id'),
      label: t('search.sections.facility.label'),
      tags: [
        {
          key: t('search.sections.facility.tags.feature_photo_sharing.key'),
          value: t('search.sections.facility.tags.feature_photo_sharing.value'),
          label: t('search.sections.facility.tags.feature_photo_sharing.label'),
        },
        {
          key: t('search.sections.facility.tags.room_environment_walking.key'),
          value: t('search.sections.facility.tags.room_environment_walking.value'),
          label: t('search.sections.facility.tags.room_environment_walking.label'),
        },
        {
          key: t('search.sections.facility.tags.feature_bus.key'),
          value: t('search.sections.facility.tags.feature_bus.value'),
          label: t('search.sections.facility.tags.feature_bus.label'),
        },
        {
          key: t('search.sections.facility.tags.after_5pm.key'),
          value: t('search.sections.facility.tags.after_5pm.value'),
          label: t('search.sections.facility.tags.after_5pm.label'),
        },
      ],
    },
    {
      id: t('search.sections.accommodation.id'),
      label: t('search.sections.accommodation.label'),
      tags: [
        {
          key: t('search.sections.accommodation.tags.room_type_whole.key'),
          value: t('search.sections.accommodation.tags.room_type_whole.value'),
          label: t('search.sections.accommodation.tags.room_type_whole.label'),
        },
        {
          key: t('search.sections.accommodation.tags.room_environment_monitor.key'),
          value: t('search.sections.accommodation.tags.room_environment_monitor.value'),
          label: t('search.sections.accommodation.tags.room_environment_monitor.label'),
        },
        {
          key: t('search.sections.accommodation.tags.bathroom_bathtub.key'),
          value: t('search.sections.accommodation.tags.bathroom_bathtub.value'),
          label: t('search.sections.accommodation.tags.bathroom_bathtub.label'),
        },
        {
          key: t('search.sections.accommodation.tags.bedroom_futon.key'),
          value: t('search.sections.accommodation.tags.bedroom_futon.value'),
          label: t('search.sections.accommodation.tags.bedroom_futon.label'),
        },
        {
          key: t('search.sections.accommodation.tags.kitchen_private.key'),
          value: t('search.sections.accommodation.tags.kitchen_private.value'),
          label: t('search.sections.accommodation.tags.kitchen_private.label'),
        },
        {
          key: t('search.sections.accommodation.tags.meal_service_breakfast.key'),
          value: t('search.sections.accommodation.tags.meal_service_breakfast.value'),
          label: t('search.sections.accommodation.tags.meal_service_breakfast.label'),
        },
        {
          key: t('search.sections.accommodation.tags.meal_service_breakfast_dinner.key'),
          value: t('search.sections.accommodation.tags.meal_service_breakfast_dinner.value'),
          label: t('search.sections.accommodation.tags.meal_service_breakfast_dinner.label'),
        },
        {
          key: t('search.sections.accommodation.tags.laundry_machine.key'),
          value: t('search.sections.accommodation.tags.laundry_machine.value'),
          label: t('search.sections.accommodation.tags.laundry_machine.label'),
        },
        {
          key: t('search.sections.accommodation.tags.laundry_dryer.key'),
          value: t('search.sections.accommodation.tags.laundry_dryer.value'),
          label: t('search.sections.accommodation.tags.laundry_dryer.label'),
        },
        {
          key: t('search.sections.accommodation.tags.room_environment_pet.key'),
          value: t('search.sections.accommodation.tags.room_environment_pet.value'),
          label: t('search.sections.accommodation.tags.room_environment_pet.label'),
        },
      ],
    },
    {
      id: t('search.sections.budget.id'),
      label: t('search.sections.budget.label'),
      tags: [
        {
          key: t('search.sections.budget.tags.budget_150k.key'),
          value: t('search.sections.budget.tags.budget_150k.value'),
          label: t('search.sections.budget.tags.budget_150k.label'),
        },
        {
          key: t('search.sections.budget.tags.budget_200k.key'),
          value: t('search.sections.budget.tags.budget_200k.value'),
          label: t('search.sections.budget.tags.budget_200k.label'),
        },
      ],
    },
    {
      id: t('search.sections.life.id'),
      label: t('search.sections.life.label'),
      tags: [
        {
          key: t('search.sections.life.tags.feature_community.key'),
          value: t('search.sections.life.tags.feature_community.value'),
          label: t('search.sections.life.tags.feature_community.label'),
        },
        {
          key: t('search.sections.life.tags.feature_historic.key'),
          value: t('search.sections.life.tags.feature_historic.value'),
          label: t('search.sections.life.tags.feature_historic.label'),
        },
        {
          key: t('search.sections.life.tags.feature_sea_town.key'),
          value: t('search.sections.life.tags.feature_sea_town.value'),
          label: t('search.sections.life.tags.feature_sea_town.label'),
        },
        {
          key: t('search.sections.life.tags.feature_snow_country.key'),
          value: t('search.sections.life.tags.feature_snow_country.value'),
          label: t('search.sections.life.tags.feature_snow_country.label'),
        },
      ],
    },
    {
      id: t('search.sections.privilege.id'),
      label: t('search.sections.privilege.label'),
      tags: [
        {
          key: t('search.sections.privilege.tags.regional_monitor.key'),
          value: t('search.sections.privilege.tags.regional_monitor.value'),
          label: t('search.sections.privilege.tags.regional_monitor.label'),
        },
        {
          key: t('search.sections.privilege.tags.exchange_rental_car.key'),
          value: t('search.sections.privilege.tags.exchange_rental_car.value'),
          label: t('search.sections.privilege.tags.exchange_rental_car.label'),
        },
        {
          key: t('search.sections.privilege.tags.privilege_regional.key'),
          value: t('search.sections.privilege.tags.privilege_regional.value'),
          label: t('search.sections.privilege.tags.privilege_regional.label'),
        },
        {
          key: t('search.sections.privilege.tags.feature_furusato.key'),
          value: t('search.sections.privilege.tags.feature_furusato.value'),
          label: t('search.sections.privilege.tags.feature_furusato.label'),
        },
      ],
    },
    {
      id: t('search.sections.transport.id'),
      label: t('search.sections.transport.label'),
      tags: [
        {
          key: t('search.sections.transport.tags.from_station_1hour.key'),
          value: t('search.sections.transport.tags.from_station_1hour.value'),
          label: t('search.sections.transport.tags.from_station_1hour.label'),
        },
        {
          key: t('search.sections.transport.tags.from_station_20min.key'),
          value: t('search.sections.transport.tags.from_station_20min.value'),
          label: t('search.sections.transport.tags.from_station_20min.label'),
        },
        {
          key: t('search.sections.transport.tags.from_station_walking.key'),
          value: t('search.sections.transport.tags.from_station_walking.value'),
          label: t('search.sections.transport.tags.from_station_walking.label'),
        },
        {
          key: t('search.sections.transport.tags.room_environment_pickup.key'),
          value: t('search.sections.transport.tags.room_environment_pickup.value'),
          label: t('search.sections.transport.tags.room_environment_pickup.label'),
        },
        {
          key: t('search.sections.transport.tags.from_tokyo_3hours.key'),
          value: t('search.sections.transport.tags.from_tokyo_3hours.value'),
          label: t('search.sections.transport.tags.from_tokyo_3hours.label'),
        },
        {
          key: t('search.sections.transport.tags.from_tokyo_shinkansen.key'),
          value: t('search.sections.transport.tags.from_tokyo_shinkansen.value'),
          label: t('search.sections.transport.tags.from_tokyo_shinkansen.label'),
        },
      ],
    },
    {
      id: t('search.sections.child.id'),
      label: t('search.sections.child.label'),
      tags: [
        {
          key: t('search.sections.child.tags.entry_requirements.key'),
          value: t('search.sections.child.tags.entry_requirements.value'),
          label: t('search.sections.child.tags.entry_requirements.label'),
        },
        {
          key: t('search.sections.child.tags.allergies.key'),
          value: t('search.sections.child.tags.allergies.value'),
          label: t('search.sections.child.tags.allergies.label'),
        },
        {
          key: t('search.sections.child.tags.developmental_anxiety.key'),
          value: t('search.sections.child.tags.developmental_anxiety.value'),
          label: t('search.sections.child.tags.developmental_anxiety.label'),
        },
      ],
    },
    {
      id: t('search.sections.area.id'),
      label: t('search.sections.area.label'),
      tags: [
        {
          key: t('search.sections.area.tags.category_hokkaido.key'),
          value: t('search.sections.area.tags.category_hokkaido.value'),
          label: t('search.sections.area.tags.category_hokkaido.label'),
        },
        {
          key: t('search.sections.area.tags.category_tohoku.key'),
          value: t('search.sections.area.tags.category_tohoku.value'),
          label: t('search.sections.area.tags.category_tohoku.label'),
        },
        {
          key: t('search.sections.area.tags.category_hokuriku.key'),
          value: t('search.sections.area.tags.category_hokuriku.value'),
          label: t('search.sections.area.tags.category_hokuriku.label'),
        },
        {
          key: t('search.sections.area.tags.category_kanto.key'),
          value: t('search.sections.area.tags.category_kanto.value'),
          label: t('search.sections.area.tags.category_kanto.label'),
        },
        {
          key: t('search.sections.area.tags.category_tokai.key'),
          value: t('search.sections.area.tags.category_tokai.value'),
          label: t('search.sections.area.tags.category_tokai.label'),
        },
        {
          key: t('search.sections.area.tags.category_chugoku.key'),
          value: t('search.sections.area.tags.category_chugoku.value'),
          label: t('search.sections.area.tags.category_chugoku.label'),
        },
        {
          key: t('search.sections.area.tags.category_kyushu.key'),
          value: t('search.sections.area.tags.category_kyushu.value'),
          label: t('search.sections.area.tags.category_kyushu.label'),
        },
      ],
    },
    {
      id: t('search.sections.text_search.id'),
      label: t('search.sections.text_search.label'),
      tags: [],
    },
  ]
}
